import api from './api';

const appointmentService = {
    // Secretary functions
    bookAppointment: async (appointmentData) => {
        const response = await api.post('/appointments/book', appointmentData);
        return response.data;
    },

    // The doctors this account may book for. One entry for a secretary attached to
    // a single doctor; a branch secretary gets every doctor in the branch.
    getBookableDoctors: async () => {
        const response = await api.get('/appointments/doctors');
        return response.data;
    },

    getTodayAppointments: async () => {
        const response = await api.get('/appointments/today');
        return response.data;
    },

    getUpcomingAppointments: async () => {
        const response = await api.get('/appointments/upcoming');
        return response.data;
    },

    checkInAppointment: async (appointmentId) => {
        const response = await api.patch(`/appointments/${appointmentId}/check-in`);
        return response.data;
    },

    notifyDoctor: async (appointmentId) => {
        const response = await api.patch(`/appointments/${appointmentId}/notify-doctor`);
        return response.data;
    },

    cancelAppointment: async (appointmentId) => {
        const response = await api.patch(`/appointments/${appointmentId}/cancel`);
        return response.data;
    },

    updateAppointment: async (appointmentId, updateData) => {
        const response = await api.patch(`/appointments/${appointmentId}/update`, updateData);
        return response.data;
    },

    // Doctor functions
    getWaitingQueue: async () => {
        const response = await api.get('/doctor/queue/waiting');
        return response.data;
    },

    getInConsultation: async () => {
        const response = await api.get('/doctor/queue/in-consultation');
        return response.data;
    },

    getScheduledAppointments: async () => {
        const response = await api.get('/doctor/queue/scheduled');
        return response.data;
    },

    completeAppointment: async (appointmentId, visitId) => {
        const response = await api.patch(`/doctor/appointments/${appointmentId}/complete`, { visitId });
        return response.data;
    },

    markAsCompleted: async (appointmentId) => {
        const response = await api.patch(`/appointments/${appointmentId}/complete`);
        return response.data;
    },

    markAsNoShow: async (appointmentId) => {
        const response = await api.patch(`/appointments/${appointmentId}/no-show`);
        return response.data;
    }
};

export default appointmentService;
